import { atom } from 'jotai'
import { GetRequest, GetRequestCached2 } from '../api'
import { GSTPayerInfo, STA_TWO_WHEELER_C_ID, UNIT_BILLED, urls } from '../constants'
import { alertAtom, globalLoaderAtom } from './globalStateAtoms'
import { receiverSectTabs, senderSectTabs } from '../constantsBooking'
import { LEYMA_CARGO, POORNIMA, STA_COMPANY_ID } from '../../../helper/companyIdhardcode'
import { NewRowData } from '../../../store/booking/booking_reducer'
import { roundOff, safeNumber } from '../mathHelper'

export const sender_ISD_Code = atom('')
export const receiver_ISD_Code = atom('')
export const newOrUsedAtom = atom(1)
export const intiateMpesaRes = atom({})
export const mpesaPaymentStatus = atom({})
export const unUtilisedMpesaList = atom([])
export const senderGSTNoAtom = atom('')
export const ewayBillNoListAtom = atom([])
export const recGstnNoAtom = atom('')
export const gstPaidByAtom = atom(GSTPayerInfo.find(({ isDefault = false }) => isDefault))
export const exemptedReasonAtom = atom('')
export const senderSectContentAtom = atom(0)
export const receiverSectContentAtom = atom(0)
export const sendMobNo2Atom = atom('')
export const recMobNo2Atom = atom('')
export const sendMailIdAtom = atom('')
export const recMailIdAtom = atom('')
export const consignerCheckAtom = atom(false)
export const slctdSndPartyAtom = atom({})
export const slctdRcvrPartyAtom = atom({})
export const consigneeCheckAtom = atom(false)
export const senderSavedDataAtom = atom({})
export const receiverSavedDataAtom = atom({})
export const BookingIDAtom = atom('')
export const methodOfPaymentDataAtom = atom([])

export const InitiateMpesaPaymentAtom = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequest(urls.paymentIntiateMpesa + '?', data)
    if (res.status === 'Success') {
      set(intiateMpesaRes, res.Data.Table[0])
    } else {
      set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data from server', nextId: '' })
    }
  } catch (error) {
    console.error(error)
    set(intiateMpesaRes, {})
  }
})
export const pollMpesaPaymentAtom = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequest(urls.confirmValidateMpesaPayment + '?', data)
    if (res.status === 'Success') {
      set(mpesaPaymentStatus, res.Data.Table[0])
    }
  } catch (error) {
    console.error(error)
    set(mpesaPaymentStatus, {})
  }
})

export const unUtilisedMpesaPaymentAtom = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequest(urls.getUnUtilisedPaymentListAll + '?', data)
    if (res.status === 'Success') {
      set(
        unUtilisedMpesaList,
        res.Data.Table.map((a) => ({ ...a, amountorder: `${a.OrderId}(KSH${a.TotalAmount})` }))
      )
    } else {
      set(alertAtom, { show: true, msg: res?.ErrMessage || 'No data from server', nextId: '' })
    }
  } catch (error) {
    console.error(error)
    set(unUtilisedMpesaList, [])
  }
})
export const senderFlagsAtom = atom({
  RemoveSenderGSTINEwayBill: 0,
  RemoveSenderID: 0,
  IsRemoveSenderOtherInfo: 0,
  RemoveBillInfo: 0,
  RemoveHomePickup: 0,
  DefaultCurrencyID: 0,
  intCompanyID: 0,
});


export const updatedSenderTabsAtom = atom((get) => {
  const tabs = [...senderSectTabs];
  const {
    RemoveSenderGSTINEwayBill,
    RemoveSenderID,
    IsRemoveSenderOtherInfo,
    RemoveBillInfo,
    RemoveHomePickup,
    DefaultCurrencyID,
    intCompanyID,
  } = get(senderFlagsAtom);

  return tabs.filter((tab) => {
    if (tab.id === 0 && (RemoveSenderGSTINEwayBill === 1 || DefaultCurrencyID === 2)) return false;
    if (tab.id === 1 && RemoveSenderID === 1) return false;
    if (tab.id === 2 && (IsRemoveSenderOtherInfo === 1 || DefaultCurrencyID === 2)) return false;
    if (tab.id === 3 && RemoveBillInfo === 1) return false;
    if (tab.id === 4 && (RemoveHomePickup === 1 || intCompanyID === STA_COMPANY_ID)) return false;
    return true;
  });
});
export const receiverFlagsAtom = atom({
  RemoveReceiverGSTIN: 0,
  IsRemoveReceiverOtherInfo: 0,
  RemoveHomeDelivery: 0,
  DefaultCurrencyID: 0,
  intCompanyID: 0,
});

export const updatedReceiverSectAtom = atom((get) => {
  const tabs = [...receiverSectTabs];
  const {
    RemoveReceiverGSTIN,
    IsRemoveReceiverOtherInfo,
    RemoveHomeDelivery,
    DefaultCurrencyID,
    intCompanyID,
  } = get(receiverFlagsAtom);

  return tabs.filter((tab) => {
    if (tab.id === 0 && (RemoveReceiverGSTIN === 1 || DefaultCurrencyID === 2)) return false;
    if (tab.id === 1 && (IsRemoveReceiverOtherInfo === 1 || DefaultCurrencyID === 2)) return false;
    if (tab.id === 2 && (RemoveHomeDelivery === 1 || intCompanyID === STA_COMPANY_ID)) return false;
    return true;
  });
});

export const rateWisePriceDataAtom = atom({})
export const insuranceChargeAtom = atom(0)
export const consignmntDataAtom = atom([{ ...NewRowData }])
export const resetConsignmentAtom=atom(null, (get, set) => {
  set(consignmntDataAtom, (prev) => [{ ...NewRowData }])
})
export const addNewConsignmentRowAtom = atom(null, (get, set) => {
  set(consignmntDataAtom, (prev) => [...prev, { ...NewRowData }])
})

export const removeConsignmentRowAtom = atom(null, (get, set, index) => {
  set(consignmntDataAtom, (prev) => prev.filter((_, i) => i !== index))
})

export const replaceConsignmentRowAtom = atom(null, (get, set, { index, newRow }) => {
  set(consignmntDataAtom, (prev) => {
    const updated = [...prev]
    updated[index] = { ...newRow }
    return updated
  })
})

export const updateConsignmentRowFieldAtom = atom(null, (get, set, { index, key, value }) => {
  set(consignmntDataAtom, (prev) => {
    if (index < 0 || index >= prev.length) return prev
    const updated = [...prev]
    const row = { ...updated[index] }
    row[key] = value
    updated[index] = row
    return updated
  })
})
export const cargoGetRateForConsignmentAtom = atom(null, async (get, set, dataset) => {
  try {
    set(globalLoaderAtom, true)
    const { data, c = {}, i, wtCharge, bU, distance = 0, IsCorporateParty = 0,rateIncrease } = dataset
    const res = await GetRequestCached2(urls.GetBookingRates, data)
    set(globalLoaderAtom, false)
    if (res.status == 'Success') {
      const { slctdCnsgnmntType = {}, unit = 1, wt_actual = 0, wt_charge = 0, inputRate = 0,MinimumWeightCharge=0 } = c
      const { IsPartySender, CompanyID, ConsignmentID, PaymentTypeID, ReceiverPartyID } = data
      const { IsKgKm = 0, IsCityPairRate = 0, IsStandardRate = 0, ConsignmentSubTypeID = 0 } = slctdCnsgnmntType
      const { Table = [], Table1 = [], Table2 = [], Table3 = [],Table4 = [] } = res?.Data
      let intActWeight = Number(wt_actual) || Number(wt_charge) || 0
      let neededTable
      let type = 0
      let rate = 0
      if (CompanyID === STA_COMPANY_ID && ConsignmentID === STA_TWO_WHEELER_C_ID && IsCorporateParty !== 1) {
        if (+distance <= 333) rate = 1000
        else rate = 2000
      } else if (IsKgKm === 1 && !IsPartySender && !ReceiverPartyID) {
        const [{ Freight: freightKgKm = 0 } = {}] = Table || []
        neededTable = Table
        type = 1
        rate = freightKgKm
      } else if ((IsStandardRate === 1 && !IsPartySender && !ReceiverPartyID) || IsCorporateParty === 1) {
        const [{ Freight: freightStandard = 0 } = {}] = Table1 || []
        neededTable = Table1
        type = 2
        rate = freightStandard
      } else if (IsCityPairRate === 1 && !IsPartySender && !ReceiverPartyID) {
        const [{ Freight: freightCityPair = 0, LocalRate: localRate = 0 } = {}] = Table2 || []
        rate = freightCityPair + localRate
        neededTable = Table2
        type = 3
      } else {
        const [{ Rate: defaultRate = 0, PartyBillingUnit = 0, PartyRate = 0 } = {}] = Table3 || []
        rate = defaultRate
        neededTable = Table3
        type = 4
        if ((IsPartySender || ReceiverPartyID) && PartyRate) {
          bU = PartyBillingUnit || bU
          rate = PartyRate
        }
      }
      let wtCharge = intActWeight
      if (IsPartySender || ReceiverPartyID) {
        const [{ PartyMinChargeWeight = 0 } = {}] = Table3 || []
        set(updateConsignmentRowFieldAtom, {
          index: i,
          key: 'PartyMinChargeWeight',
          value: PartyMinChargeWeight,
        })
        wtCharge = unit * PartyMinChargeWeight > intActWeight ? unit * PartyMinChargeWeight : intActWeight
        set(updateConsignmentRowFieldAtom, {
          index: i,
          key: 'wt_charge',
          value: wtCharge,
        })
        set(updateConsignmentRowFieldAtom, {
          index: i,
          key: 'wt_charge2',
          value: wtCharge,
        })
      } else {
        set(updateConsignmentRowFieldAtom, {
          index: i,
          key: 'PartyMinChargeWeight',
          value: 0,
        })
      }
      let insuranceCharge = 0
      if (IsCorporateParty === 1) {
        insuranceCharge = Table1?.[0]?.Valuation || 0
        if (Table1?.[0]?.ValuationBillUnit === 1) {
          insuranceCharge = +wt_charge * (Table1?.[0]?.Valuation || 0)
        } else if (Table1?.[0]?.ValuationBillUnit === 2) {
          insuranceCharge = +unit * (Table1?.[0]?.Valuation || 0)
        }
      } else {
        insuranceCharge = Table3?.[0]?.InsuranceCharges || 0
      }
      set(rateWisePriceDataAtom, (prev) => ({
        ...prev,
        [i]: {
          ConsignmentSubTypeID,
          Type: type,
          data: neededTable,
          data2: Table3,
          bU,
          wtCharge,
          unit,
          data3 :Table4,
        },
      }))
      set(insuranceChargeAtom, insuranceCharge)
      if (PaymentTypeID === 3) {
        rate = 0
      }
      if(rateIncrease){
        rate = rate + rate * rateIncrease / 100
      }
      set(updateConsignmentRowFieldAtom, {
        index: i,
        key: 'rate2',
        value: rate,
      })
      if (bU && [1, 2].includes(bU)) {
        if (IsPartySender) {
          set(updateConsignmentRowFieldAtom, {
            index: i,
            key: 'freight2',
            value: bU === 2 ? unit * rate : +wtCharge * rate,
          })
        } else {
          set(updateConsignmentRowFieldAtom, {
            index: i,
            key: 'freight2',
            value: bU === 2 ? unit * rate : +wt_charge * rate,
          })
        }
      }
      if (inputRate) {
        rate = inputRate
      }
      set(updateConsignmentRowFieldAtom, {
        index: i,
        key: 'rate',
        value: inputRate ? inputRate : rate,
      })
      if (bU && [1, 2].includes(bU)) {
      const weight = IsPartySender ? wtCharge : wt_charge;
      let freight = 0;
        if (PaymentTypeID === 3) {
          set(updateConsignmentRowFieldAtom, { index: i, key: 'freight', value: 0 })
          set(updateConsignmentRowFieldAtom, { index: i, key: 'freight2', value: 0 })
          return
        }
      if (bU === UNIT_BILLED || (IsKgKm === 1 && !IsPartySender && !ReceiverPartyID && CompanyID === LEYMA_CARGO)) {
        freight = unit * rate;
      } else {
        if (CompanyID === STA_COMPANY_ID && IsCityPairRate === 1) {
          const [{ Freight: freightCityPair = 0, LocalRate: localRate = 0 } = {}] = Table2 || []
          rate = freightCityPair + localRate
          const excessWight = Number(wt_charge) - safeNumber(MinimumWeightCharge)*Number(unit);
          freight = Number(Table2?.[0]?.MinFreight)*Number(unit) || 0;
          if (excessWight > 0) {
            freight += excessWight * rate
          }
          set(updateConsignmentRowFieldAtom, {
              index: i,
              key: 'freight2',
              value: freight,
            })
        } else {
          freight = Number(weight) * rate;
        }
      }

      set(updateConsignmentRowFieldAtom, {
        index: i,
        key: 'freight',
        value: roundOff(freight, CompanyID === POORNIMA),
      });
    }
    } else {
    }
  } catch (err) {
    console.error('Rate fetch error:', err)
  } finally {
    set(globalLoaderAtom, false)
  }
})
export const getProfileByNameNumberAtom = atom(null, async (get, set, data) => {
  try {
    const res = await GetRequest(urls.getNameAndAddress, data)
    if (res.status === 'Success') {
      if (data.strType === 'S') {
        set(senderSavedDataAtom, res.Data.Table[0] || {})
      }
      if (data.strType === 'R') {
        set(receiverSavedDataAtom, res.Data.Table[0] || {})
      }
    }
  } catch (error) {
    console.error(error)
  }
})
const getSessionValue = (key) => {
  return JSON.parse(sessionStorage.getItem(key)) || {}
}
const setSessionValue = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value))
}
const startingCityKey = 'senderCityKey'
const senderCityBaseAtom = atom(getSessionValue(startingCityKey))
export const senderCityAtom = atom(
  (get) => get(senderCityBaseAtom),
  (get, set, newValue) => {
    set(senderCityBaseAtom, newValue)
    setSessionValue(startingCityKey, newValue)
  }
)
const destinationCityKey = 'destinationCityKey'
const destinationCityBaseAtom = atom(getSessionValue(destinationCityKey))
export const destinationCityAtom = atom(
  (get) => get(destinationCityBaseAtom),
  (get, set, newValue) => {
    set(destinationCityBaseAtom, newValue)
    setSessionValue(destinationCityKey, newValue)
  }
)
const startingBranchKey = 'senderBranchKey'
const senderBranchBaseAtom = atom(getSessionValue(startingBranchKey))
export const senderBranchAtom = atom(
  (get) => get(senderBranchBaseAtom),
  (get, set, newValue) => {
    set(senderBranchBaseAtom, newValue)
    setSessionValue(startingBranchKey, newValue)
  }
)
const destinationBranchKey = 'destinationBranchKey'
const destinationBranchBaseAtom = atom(getSessionValue(destinationBranchKey))
export const destinationBranchAtom = atom(
  (get) => get(destinationBranchBaseAtom),
  (get, set, newValue) => {
    set(destinationBranchBaseAtom, newValue)
    setSessionValue(destinationBranchKey, newValue)
  }
)
const vehicleNoKey = 'vehicleNoKey'
const vehicleNoBaseAtom = atom(getSessionValue(vehicleNoKey))
export const vehicleNoAtom = atom(
  (get) => get(vehicleNoBaseAtom),
  (get, set, newValue) => {
    set(vehicleNoBaseAtom, newValue)
    setSessionValue(vehicleNoKey, newValue)
  }
)
const companyTaxKey = 'companyTaxKey'
const companyTaxBaseAtom = atom(getSessionValue(companyTaxKey))
export const companyTaxAtom = atom(
  (get) => get(companyTaxBaseAtom),
  (get, set, newValue) => {
    set(companyTaxBaseAtom, newValue)
    setSessionValue(companyTaxKey, newValue)
  }
)